export const ERROR_KEYS = [
	'INTERNAL_SERVER_ERROR',
	'HTTP_EXCEPTION',
	'INVALID_SESSION_STATE',
	'BANK_NOT_FOUND',
	'VENDOR_TIMEOUT',
	'BANK_INTEGRATION_EXCEPTION',
	'UNSUPPORTED_FLOW',
	'UNSUPPORTED_CONSENT_APPROACH',
	'UNSUPPORTED_ACTION',
	'REDIRECT_URL_NOT_DEFINED',
	'INVALID_RESPONSE_STATUS',
	'SESSION_NOT_FOUND',
	'UNRECOGNISED_CONSENT_STATUS',
	'BAD_PARAMS',
	'UNAUTHORIZED',
	'MODULE_INIT_NOT_CALLED',
	'BANK_HAS_NO_SUPPORTED_INTERFACE',
	'VENDOR_BANK_NOT_FOUND',
	'VENDOR_SESSION_NOT_FOUND',
	'LOGIN_CREDENTIALS_EXPIRED',
	'NETWORK',
	'TECHNICAL'
] as const;

export type ErrorKey = (typeof ERROR_KEYS)[number];

export const ERROR_KEYS_WITH_SPECIFIC_MESSAGE: Array<ErrorKey> = [
	'BANK_NOT_FOUND',
	'VENDOR_TIMEOUT',
	'BANK_INTEGRATION_EXCEPTION',
	'LOGIN_CREDENTIALS_EXPIRED'
];

export class FincredibleBankException extends Error {
	public constructor(
		readonly errorKey: ErrorKey,
		readonly context: any,
		readonly reference?: string,
		readonly traceId?: string
	) {
		super();
		Object.setPrototypeOf(this, FincredibleBankException.prototype);
	}
}
